import { Component } from '@angular/core';
import { CurrencyPipe, NgClass, NgTemplateOutlet } from '@angular/common';
import { EmptyIndicatorPipe } from '../../../../../shared/pipes/empty-indicator.pipe';
import { AccountBalanceWidgetComponent } from '../../../dashboard/widgets/account-balance-widget/account-balance-widget.component';

@Component({
  selector: 'app-fund-account-balance-widget',
  imports: [CurrencyPipe, NgClass, NgTemplateOutlet, EmptyIndicatorPipe],
  templateUrl: './fund-account-balance-widget.component.html',
})
export class FundAccountBalanceWidgetComponent extends AccountBalanceWidgetComponent {}
